// @flow

import { alertShow } from "./alert";
import { communicationsError, communicationsInProgress, communicationsSuccess } from "./communications";
import { databaseUpdate } from "./database";
import { join } from "../channel";

import type { Channel } from "phoenix";
import type { Dispatch } from "redux";

export function loadData(dispatch: Dispatch, channel: string, event: string, data: {}) {
  var promise = sendMessage(join(channel), event, data)
    .then(reply => {
      dispatch(databaseUpdate(reply));
      return reply;
    });
  return wrapWithComms(promise, dispatch, event);
}

export function sendMessageWithCommsAndAlert(dispatch: Dispatch, topic: string, event: string, data: {}) {
  var channel = join(topic);
  var promise = sendMessage(channel, event, data);
  promise = wrapWithComms(promise, dispatch, event);
  promise = wrapWithAlertError(promise, dispatch, errors => errors.reason);
  return promise;
}

export function sendMessage(channel: Channel, event: string, data: {}) {
  return new Promise((resolve, reject) => {
    channel
      .push(event, data)
      .receive("ok", resolve)
      .receive("error", reject);
  });
}

export function wrapWithAlertSuccess(promise: Promise<any>, dispatch: Dispatch, title: string, text: ?string) {
  return promise
    .then(reply => {
      dispatch(alertShow("notification--success", "dw-checkmark3", title, text));
      return reply;
    });
}

const defaultErrorMessage = "An error is preventing the form from being submitted.";
export function wrapWithAlertError(promise: Promise<any>, dispatch: Dispatch, messageGenerator: (any) => string) {
  return promise
    .catch(err => {
      var message = messageGenerator(err) || defaultErrorMessage;
      dispatch(alertShow("notification--error", "dw-blocked", "Error", message));
      throw err;
    });
}

export function wrapWithComms(promise: Promise<any>, dispatch: Dispatch, id: string) {
  dispatch(communicationsInProgress(id));
  return promise
    .then(reply => {
      dispatch(communicationsSuccess(id));
      return reply;
    })
    .catch(err => {
      console.error(err);
      dispatch(communicationsError(id, err));
      throw err;
    });
}
